import homegrownFullLogoSRC from 'Assets/homegrown-logo-full.png';
import notFoundImage from 'Assets/images/404-item-image.png';

import { SUPPORT_EMAIL } from '../constants.ts';

export function NotFoundPage() {
    return (
        <div className="relative min-h-screen px-4 flex items-center justify-center bg-background">
            <img
                src={homegrownFullLogoSRC}
                alt="Homegrown"
                className="absolute top-6 left-6 h-10"
            />

            <div className="w-full max-w-[550px] flex flex-col items-center">
                <img
                    src={notFoundImage}
                    alt="Not found"
                    className="w-[100px] min-[600px]:w-[132px] aspect-132/109 object-cover object-top"
                />

                <div className="z-[1] px-5 py-6 min-[600px]:p-[30px] flex flex-col items-center self-stretch gap-3.5 min-[600px]:gap-5 rounded-[20px] bg-foreground text-background">
                    <p className="text-center text-[24px] min-[600px]:text-[32px] font-Telegraf font-bold">
                        Error 404
                    </p>

                    <p className="text-center text-[16px] min-[600px]:text-[24px] font-normal leading-[1.2]">
                        The page you are looking for might have been moved, deleted, or never
                        existed.
                    </p>
                </div>

                <p className="mt-6 text-center text-[16px] min-[600px]:text-[24px] font-normal text-foreground">
                    Don&apos;t worry, your data and applications are safe
                </p>
            </div>

            <p className="absolute bottom-6 text-center text-[14px] min-[600px]:text-[16px] font-normal text-foreground">
                Need support? Reach out to{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">
                    {SUPPORT_EMAIL}
                </a>
            </p>
        </div>
    );
}
